<template>
    <div class="w-full">
        <div
            class="flex h-16 border-b border-grey-500 gap-6 relative"
            ref="buttons"
            :class="[headerCSS, { 'lg:hidden': mobileOnly }]"
            v-if="tabs.length > 0"
        >
            <button
                v-for="(tab, i) in tabs"
                @click="setIndex(i)"
                class="tab-button"
                :class="{ '!text-black': i == index }"
            >
                <template v-if="!$slots.tab">
                    {{ tab.html }}
                </template>

                <slot name="tab" :tab="tab" :i="i" :active="i == index" />
            </button>

            <div class="absolute -bottom-px bg-purple-600 h-0.5 transition-all duration-300" :style="bar" />
        </div>

        <!-- relative flex lg:grid grid-cols-12 items-stretch place-items-stretch overflow-x-scroll overflow-y-clip lg:overflow-auto -mx-4 px-4 lg:px-0 lg:mx-0 -->

        <div class="tab-content lg:!max-h-[unset]" ref="tabContent" v-if="$slots.default" :class="contentClass">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tabs: { type: Array, default: [] },
        loadIndex: { type: Number, default: 0 },
        mobileOnly: { type: Boolean, default: true },
        contentClass: { type: String, default: '' },
        headerCSS: { type: String, default: null },
    },

    emits: ['tabChange'],

    mounted() {
        this.$event.$on('page-loaded', () => {
            setTimeout(() => {
                this.setIndex(this.index)
            }, 300)
        })

        if (this.$refs.tabContent == undefined || this.$refs.tabContent?.children.length == 0) {
            return
        }

        this.$refs.tabContent.addEventListener(
            'touchstart',
            (e) => {
                this.touchstartX = e.changedTouches[0].screenX
                this.touchstartY = e.changedTouches[0].screenY
            },
            { passive: true },
        )

        this.$refs.tabContent.addEventListener(
            'touchend',
            (e) => {
                this.touchendX = e.changedTouches[0].screenX
                this.touchendY = e.changedTouches[0].screenY
                this.checkDirection()
            },
            { passive: true },
        )

        this.$refs.tabContent.addEventListener(
            'wheel',
            (event) => {
                if (event.deltaX !== 0) {
                    event.preventDefault()
                }
            },
            { passive: false },
        )
    },

    data() {
        return {
            index: this.loadIndex,
            bar: {
                left: '0px',
                width: '0px',
            },
        }
    },

    methods: {
        setIndex(index = 0) {

            try {
                this.bar = {
                    left: this.$refs.buttons.children[index].offsetLeft + 'px',
                    width: this.$refs.buttons.children[index].clientWidth + 'px',
                }
            } catch (e) {
                console.log(e)
            }

            if (this.$slots.default && this.$refs.tabContent != null) {
                this.$refs.tabContent.scroll({
                    left: this.$refs.tabContent.children[index].offsetLeft - 16,
                    behavior: 'smooth',
                })

                this.$refs.tabContent.style.maxHeight = this.$refs.tabContent.children[index].clientHeight + 'px'
            }

            this.index = index

            this.$emit('tabChange', this.index)
        },

        checkDirection() {
            let minMove = 80
            let vertical = Math.abs(this.touchstartY - this.touchendY)
            let horizontal = Math.abs(this.touchstartX - this.touchendX)

            // console.log('vertical movement', vertical)
            // console.log('horizontal movement', horizontal)
            // console.log('vertical is more than horizontal', vertical > horizontal)
            // console.log('vertical is more than 20', vertical >= minMove)
            // console.log('horizontal is less than min', horizontal < minMove)

            // this.str =
            //     'vertical movement: '+vertical
            //     +'<br />'+ 'horizontal movement: '+ horizontal
            //     +'<br />'+ 'vertical is more than horizontal: '+(vertical > horizontal)
            //     +'<br />'+ 'vertical is more than 20: '+(vertical > 20)
            //     +'<br />'+ 'horizontal is less than min: '+(horizontal < minMove)
            // ;

            if (vertical > horizontal || (vertical >= minMove && horizontal < minMove) || horizontal < minMove) {
                this.setIndex(this.index)
                return
            }

            let index = this.index + (this.touchendX < this.touchstartX ? 1 : -1)

            if (index >= this.tabs.length - 1) {
                index = this.tabs.length - 1
            }

            if (index < 0) {
                index = 0
            }

            if (index != this.index) {
                this.setIndex(index)
            }
        },
    },
}
</script>
